// src\constants\about-me.constants.js

export const ABOUT_TITLE = 'About Me';
export const ABOUT_HEADER = 'who i am';
export const INTRO_TITLE = `I develop interactive web-apps at Axis Bank`;
export const INTRO_PARAGRAPH = `Currently, I am working as a full stack software engineer at Axis
Bank having a role of Lead Full Stack Engineer, Strong engineering
professional with a Bachelor's degree focused in Information
Technology. Knowledgeable of backend and front-end development
requirements. Handles any part of the process with ease. An
enthusiastic team player and deep creative thinker.`;
export const DOWNLOAD_CV_TEXT = `Download CV`;
